import { request } from './apiClient'

export function fetchUser() {
  return request('GET', '/v1/me')
}
